
import CKEditor from '@ckeditor/ckeditor5-vue2';
import {
    ClassicEditor,
    Bold,
    Essentials,
    Italic,
    Mention,
    Paragraph,
    Undo,
    Heading,
    Autoformat,
    CloudServices,
    Indent,
    Underline,
    Link,
    List,
    PasteFromOffice,
    TextTransformation,
} from '../../../node_modules/ckeditor5';
import 'ckeditor5/ckeditor5.css';

import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
    components: {
        ckeditor: CKEditor.component,
    }
})
export default class CKEditor5 extends Vue {
    @Prop({ default: '' }) value!: string;
    @Prop({ default: false }) readonly!: boolean;
    @Prop({ default: false }) disabled!: boolean;

    content: string = '';
    
    get editor() {
        return ClassicEditor;
    }

    get editorConfig() {
        return {
            language: 'en',
            toolbar: {
                items: ['undo', 'redo', '|', 'heading', 'bold', 'italic', '|', 'underline', 'bulletedList', 'numberedList', 'link'],
            },
            plugins: [
                Autoformat,
                CloudServices,
                Indent,
                Underline,
                Link,
                List,
                PasteFromOffice,
                TextTransformation,
                Undo,
                Bold,
                Essentials,
                Italic,
                Mention,
                Paragraph,
                Undo,
                Heading
            ],
        };
    }

    created() {
        this.content = this.value;   
    }
}
